import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import NombreCliente from '../../components/NombreCliente';
import Vencimiento from '../../components/Vencimiento';
import FechaPago from '../../components/FechaPago';
import { money, fechaCorta, Badge, Empty, ESTADO_COBRO } from './ui';

// Cómo se agrupan los cobros en los reportes
export const GRUPOS = {
  pagado: { estado: 'pagado', titulo: 'Cobrado', ayuda: 'Ya entró la plata.' },
  abiertos: { estado: 'abiertos', titulo: 'Pendiente de cobro', ayuda: 'Ya se lo pasamos al cliente y todavía no pagó.' },
  informado: { estado: 'informado', titulo: 'Informados por el cliente', ayuda: 'Avisaron que pagaron: falta que lo confirmes.' },
  a_pasar: { estado: 'a_pasar', titulo: 'A pasar', ayuda: 'Cuotas futuras que todavía no habilitaste. No cuentan como facturado.' },
};

/* Listado de los cobros que hay detrás de un número */
export default function DetalleCobros({ grupo, desde, hasta, etiqueta, onClose }) {
  const [filas, setFilas] = useState(null);
  const navigate = useNavigate();
  const g = GRUPOS[grupo] || GRUPOS.pagado;

  const cargar = useCallback(() => {
    api.get('/agency/cobros', { params: { estado: g.estado, desde, hasta, limit: 300 } })
      .then(r => setFilas(r.data.cobros)).catch(() => toast.error('No se pudo cargar el detalle'));
  }, [g.estado, desde, hasta]);

  useEffect(() => { setFilas(null); cargar(); }, [cargar]);

  const th = { textAlign: 'left', fontSize: 11, color: 'var(--text-muted)', fontWeight: 700, padding: '6px 8px' };
  const td = { padding: '8px', borderTop: '1px solid var(--border)', fontSize: 13 };
  const total = (filas || []).reduce((a, c) => a + Number(c.monto || 0), 0);

  return (
    <div className="card" style={{ marginBottom: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
        <div>
          <h3 style={{ fontSize: 16, fontWeight: 700 }}>{g.titulo}{etiqueta ? ` · ${etiqueta}` : ''}</h3>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>
            {g.ayuda} {filas && `${filas.length} cobros · ${money(total)}`}
          </div>
        </div>
        <button className="btn btn-ghost btn-sm" onClick={onClose} title="Cerrar"><X size={16} /></button>
      </div>

      <div style={{ marginTop: 12 }}>
        {!filas ? <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>Cargando...</div>
          : filas.length ? (
            <div className="table-container">
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead><tr><th style={th}>Cliente</th><th style={th}>Concepto</th><th style={th}>Emitido</th><th style={th}>Vence</th>
                  <th style={{ ...th, textAlign: 'right' }}>Monto</th><th style={th}>Estado</th></tr></thead>
                <tbody>{filas.map(c => {
                  const e = ESTADO_COBRO[c.estado] || {};
                  return (
                    <tr key={c.id} style={{ cursor: 'pointer' }} onClick={() => navigate('/agencia/clientes/' + c.cliente_id)}>
                      <td style={{ ...td, fontWeight: 600 }}><NombreCliente nombre={c.cliente} logo={c.logo_url} /></td>
                      <td style={td}>{c.concepto || '—'}</td>
                      <td style={{ ...td, whiteSpace: 'nowrap', fontSize: 12, color: 'var(--text-muted)' }} onClick={ev => ev.stopPropagation()}>
                        <Vencimiento cobro={c} campo="emitido" onCambio={cargar}>{fechaCorta(c.emitido)}</Vencimiento>
                      </td>
                      <td style={{ ...td, whiteSpace: 'nowrap', fontSize: 12 }} onClick={ev => ev.stopPropagation()}>
                        <Vencimiento cobro={c} onCambio={cargar}>{fechaCorta(c.vencimiento)}</Vencimiento>
                      </td>
                      <td style={{ ...td, textAlign: 'right', fontWeight: 600 }}>{money(c.monto)}</td>
                      <td style={td} onClick={ev => c.estado === 'pagado' && ev.stopPropagation()}>
                        <Badge label={c.habilitado ? e.label : 'A pasar'}
                          color={c.habilitado ? e.color : '#64748b'} bg={c.habilitado ? e.bg : 'rgba(100,116,139,0.15)'} />
                        {c.estado === 'pagado' && (
                          <div style={{ marginTop: 3 }}><FechaPago cobro={c} editable onCambio={cargar} /></div>
                        )}
                      </td>
                    </tr>
                  );
                })}</tbody>
              </table>
            </div>
          ) : <Empty>No hay cobros de este tipo en el período</Empty>}
      </div>
    </div>
  );
}
